export const withTimeout = async <T>(
    promise: Promise<T>,
    timeoutMs: number,
    label = 'Optimizer initialization',
): Promise<T> =>
    await Promise.race([
        promise,
        new Promise<never>((_, reject) => {
            setTimeout(() => {
                reject(new Error(`${label} timed out after ${timeoutMs}ms`));
            }, timeoutMs);
        }),
    ]);
